export default __webpack_public_path__ + "static/media/Anton-Regular.170b842f.ttf";